export const convertToSafeName = (str: string): string => {
  // Replace all unwanted characters with an underscore (_)
  str = str.replace(/[^a-zA-Z0-9._-]/g, "_");

  // Replace multiple consecutive underscores or dashes with a single underscore
  str = str.replace(/[_-]+/g, "_");

  // Remove leading/trailing undesired characters (underscores, dashes, dots)
  str = str.replace(/^[_-]+|[_-]+$/g, "");

  return str;
};

/**
 * Format a date string to a human-readable format  
 * @param date - The date string to format
 * @returns The formatted date string in the format "HH:mm MM/DD/YYYY"
 */
export const formatDate = (date: string): string => {
  return new Date(date).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};